import React, { useEffect, useRef, useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import "./CityDropdown.css";

const CityDropdown = ({ value, options = [], placeholder = "Select", onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel = options.find((option) => option.value === value)?.label;

  const handleSelect = (optionValue) => {
    onChange?.(optionValue);
    setIsOpen(false);
  };

  return (
    <div className="city-dropdown" ref={containerRef}>
      <button
        type="button"
        className="city-dropdown-trigger"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className={`city-dropdown-value${selectedLabel ? "" : " placeholder"}`}>
          {selectedLabel || placeholder}
        </span>
        <DownOutlined className={`city-dropdown-arrow${isOpen ? " open" : ""}`} />
      </button>
      {isOpen && (
        <ul className="city-dropdown-menu">
          {options.length ? (
            options.map((option) => (
              <li
                key={option.value}
                className={`city-dropdown-option${option.value === value ? " active" : ""}`}
                onClick={() => handleSelect(option.value)}
              >
                {option.label}
              </li>
            ))
          ) : (
            <li className="city-dropdown-option city-dropdown-empty">No cities available</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default CityDropdown;
